import {Injectable} from "@angular/core";
import {Router} from '@angular/router';
import {Session} from "./session.model";
import {User} from "./user.model";
import { CookieService } from 'ng2-cookies';
import {Headers} from "@angular/http";

@Injectable()
export class StorageService {

  private currentSession : Session = null;

  constructor(private router: Router, private cookieService : CookieService) {
    this.currentSession = this.loadSessionData();
  }
  
  isAuthenticated(): boolean {
    return (this.getCurrentToken() != null) ? true : false;
  };

  setCurrentSession(session: Session): void {
    this.currentSession = session;
    this.cookieService.set('currentUser', JSON.stringify(session));
  }

  loadSessionData(): Session{
    var sessionStr = this.cookieService.get('currentUser');
    return (sessionStr) ? <Session> JSON.parse(sessionStr) : null;
  }

  getCurrentSession(): Session {
    return this.currentSession;
  }

  removeCurrentSession(): void {
    this.cookieService.delete('currentUser');
    this.currentSession = null;
  }

  getCurrentUser(): User {
    var session: Session = this.getCurrentSession();
    return (session && session.user) ? session.user : null;
  };

  getCurrentToken(): string {
    var session = this.getCurrentSession();
    return (session && session.token) ? session.token : null;
  };
  
  getCurrentMenu(): string {
    var session = this.getCurrentSession();
    return (session && session.token) ? session.token : null;
  };
    
  getHeaders(): Headers{
    let h = new Headers();
    h.append('Content-Type',  'application/json');
    h.append('Authorization', 'Bearer ' + this.getCurrentToken());
    h.append('customerId', String(this.getCurrentUser().accountId));
    h.append('accountId', String(this.getCurrentUser().accountId));
    return h;
    };

}
